import { render, staticRenderFns } from "./digRthree.vue?vue&type=template&id=ed390cb0&scoped=true"
import script from "./digRthree.vue?vue&type=script&lang=js"
export * from "./digRthree.vue?vue&type=script&lang=js"
import style0 from "./digRthree.vue?vue&type=style&index=0&id=ed390cb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed390cb0",
  null
  
)

export default component.exports